// extracted by mini-css-extract-plugin
export default {"box-header":"a3f8e9","boxHeader":"a3f8e9","box-header__children":"b4fbc6","boxHeaderChildren":"b4fbc6"};